(function () {
  function getBenefitValues() {
  const config = window.ACBenefits;

  if (!config) return null;

  const currency =
    window.Shopify?.currency?.active ||
    config.currency ||
    'EUR';

  const rate = Number(
    window.Shopify?.currency?.rate || 1
  );

  function convertThreshold(baseCents) {
    const converted =
      Number(baseCents || 0) * rate;

    if (currency === 'EUR') {
      return Math.round(converted);
    }

    return Math.ceil(converted / 100) * 100;
  }

  const giftCents =
    convertThreshold(
      config.giftBaseCents
    );

  const halfShippingCents =
    convertThreshold(
      config.halfShippingBaseCents
    );

  const freeShippingCents =
    convertThreshold(
      config.shippingBaseCents
    );

  const formatter =
    new Intl.NumberFormat(
      document.documentElement.lang ||
        undefined,
      {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }
    );

  return {
    currency,
    rate,

    giftCents,
    halfShippingCents,
    freeShippingCents,

    giftFormatted:
      formatter.format(
        giftCents / 100
      ),

    halfShippingFormatted:
      formatter.format(
        halfShippingCents / 100
      ),

    freeShippingFormatted:
      formatter.format(
        freeShippingCents / 100
      )
  };
}

  function updateBenefitAmounts() {
    const values = getBenefitValues();

    if (!values) return;

    window.ACBenefits.current = values;

    document
      .querySelectorAll('[data-ac-gift-amount]')
      .forEach((element) => {
        element.textContent =
          values.giftFormatted;
      });

    document
      .querySelectorAll('[data-ac-half-shipping-amount]')
      .forEach((element) => {
        element.textContent =
          values.halfShippingFormatted;
      });

    document
      .querySelectorAll('[data-ac-free-shipping-amount]')
      .forEach((element) => {
        element.textContent =
          values.freeShippingFormatted;
      });

    document.dispatchEvent(
      new CustomEvent('ac:benefits-updated', {
        detail: values
      })
    );
  }

  window.ACBenefits.getValues =
    getBenefitValues;

  window.ACBenefits.update =
    updateBenefitAmounts;

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateBenefitAmounts
    );
  } else {
    updateBenefitAmounts();
  }

  document.addEventListener(
    'shopify:section:load',
    updateBenefitAmounts
  );

  window.addEventListener(
    'pageshow',
    updateBenefitAmounts
  );
})();